"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var errorDialog_1 = require("spry-react/Errors/errorDialog");
function Render403ErrorDialog(close) {
    return React.createElement(errorDialog_1.ErrorDialog, { close: close, singleTabText: "Forbidden" },
        React.createElement("h2", null, "You do not have permission to execute this action."));
}
exports.Render403ErrorDialog = Render403ErrorDialog;
